
import React, { useEffect, useState } from 'react';
import {
  Table, Thead, Tbody, Tr, Th, Td, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  useDisclosure, Badge, Flex, Text,
  Box
} from '@chakra-ui/react';
import SolicitudAnuncio from '../Ventanas/SolicitudAnuncio';
import axiosInstance from '../../../api/AxiosInstance'; 

const TablaSolicitudAnuncio: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    axiosInstance.get('/obras/solicitud-anuncio')
        .then(res => setData(res.data))
      .catch(() => setData([]))
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handleRowClick = (item: any) => {
    setSelectedItem(item);
    onOpen();
  };

  const handleRowClickEdit = (item: any) => {
    setSelectedItem(item);
    onOpenEdit();
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
    <Table variant="simple" size="sm">
      <Thead bg="#5b182b">
          <Tr>
            <Th color="white">ID</Th>
            <Th color="white">Tipo</Th>
            <Th color="white">Dimensiones</Th>
            <Th color="white">Responsable</Th>
            <Th color="white">Costo</Th>
            <Th color="white">Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item) => (
            <Tr key={item.id}>
              <Td>{item.id}</Td>
              <Td>{item.tipo}</Td>
              <Td>{item.ancho}x{item.alto}m</Td>
              <Td>{item.responsable}</Td>
              <Td>${item.costo}</Td>
              <Td>
                <Button size="sm" onClick={() => handleRowClick(item)}>Ver</Button>{' '}
                <Button size="sm" onClick={() => handleRowClickEdit(item)}>Editar</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex mt={4} justify="center" gap={2}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i + 1}
            size="sm"
            colorScheme={currentPage === i + 1 ? 'blue' : 'gray'}
            onClick={() => paginate(i + 1)}
          >
            {i + 1}
          </Button>
        ))}
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detalle de Solicitud</ModalHeader>
          <ModalBody>
            {selectedItem ? (
              <SolicitudAnuncio modo="view" data={selectedItem} />
            ) : (
              <Text>No hay datos para mostrar.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenEdit} onClose={onCloseEdit} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Editar Solicitud</ModalHeader>
          <ModalBody>
            {selectedItem ? (
              <SolicitudAnuncio modo="edit" data={selectedItem} />
            ) : (
              <Text>No hay datos para editar.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseEdit}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaSolicitudAnuncio;